import { render, staticRenderFns } from "./ManageCareers.vue?vue&type=template&id=1ae4870c&scoped=true"
import script from "./ManageCareers.vue?vue&type=script&lang=js"
export * from "./ManageCareers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4870c",
  null
  
)

export default component.exports